import { transport } from 'config/transport';

export function callApiExportThuChiBanNganh(academicYear) {
    return transport.get(`/bannganh/thuchi/exportReport`, { params: { academicYear }, responseType: 'blob' });
}
